// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._403_form403Container__5NOIC {
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  color: #000;
  line-height: 1.6;
  direction: ltr;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 20px auto;
}
._403_form403Container__5NOIC ._403_tabNavigation__B6X6k {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
._403_form403Container__5NOIC ._403_tabNavigation__B6X6k ._403_tabButton__awgah {
  flex: 1 1;
  padding: 20px 30px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
._403_form403Container__5NOIC ._403_tabNavigation__B6X6k ._403_tabButton__awgah:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateY(-2px);
}
._403_form403Container__5NOIC ._403_tabNavigation__B6X6k ._403_tabButton__awgah._403_active__TlUsF {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: inset 0 -3px 0 #fff;
}
._403_form403Container__5NOIC ._403_tabNavigation__B6X6k ._403_tabButton__awgah._403_active__TlUsF::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #fff;
  border-radius: 2px;
}

@media (max-width: 768px) {
  ._403_form403Container__5NOIC {
    margin: 10px;
    padding: 15px;
  }
  ._403_form403Container__5NOIC ._403_tabNavigation__B6X6k {
    flex-direction: column;
  }
  ._403_form403Container__5NOIC ._403_tabNavigation__B6X6k ._403_tabButton__awgah {
    padding: 15px 20px;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/403.module.scss"],"names":[],"mappings":"AAAA;EACE,sDAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iBAAA;EACA,iBAAA;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,6DAAA;EACA,4BAAA;EACA,gBAAA;EACA,yCAAA;AAAJ;AAEI;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sDAAA;AAAN;AAEM;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;AAAR;AAGM;EACE,oCAAA;EACA,YAAA;EACA,+BAAA;AADR;AAGQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AADV;;AASA;EACE;IACE,YAAA;IACA,aAAA;EANF;EAQE;IACE,sBAAA;EANJ;EAQI;IACE,kBAAA;IACA,eAAA;EANN;AACF","sourcesContent":[".form403Container {\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  margin: 20px;\n  padding: 20px;\n  background-color: #fff;\n  color: #000;\n  line-height: 1.6;\n  direction: ltr;\n  text-align: left;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 1200px;\n  margin: 20px auto;\n\n  // Tab Navigation\n  .tabNavigation {\n    display: flex;\n    margin-bottom: 30px;\n    border-bottom: 2px solid #e9ecef;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 12px 12px 0 0;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n    .tabButton {\n      flex: 1;\n      padding: 20px 30px;\n      background: transparent;\n      border: none;\n      color: rgba(255, 255, 255, 0.8);\n      font-size: 1.1rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      position: relative;\n      font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.1);\n        color: white;\n        transform: translateY(-2px);\n      }\n\n      &.active {\n        background: rgba(255, 255, 255, 0.2);\n        color: white;\n        box-shadow: inset 0 -3px 0 #fff;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 3px;\n          background: #fff;\n          border-radius: 2px;\n        }\n      }\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .form403Container {\n    margin: 10px;\n    padding: 15px;\n\n    .tabNavigation {\n      flex-direction: column;\n\n      .tabButton {\n        padding: 15px 20px;\n        font-size: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form403Container": `_403_form403Container__5NOIC`,
	"tabNavigation": `_403_tabNavigation__B6X6k`,
	"tabButton": `_403_tabButton__awgah`,
	"active": `_403_active__TlUsF`
};
export default ___CSS_LOADER_EXPORT___;
